
import { defineComponent, SetupContext, PropType, ref, computed, toRefs, watch, onMounted } from "vue";
import { FridgeDetailsDoorOpenInfoDailyItem } from "@/types/fridgeDetails"
import NativeClient from "@/client/native-client";
import { translateYYYYMMDDToYYYYMDJapan } from "@/utils/common-utils";
import FridgeDetailsSelectDateBar from "@/components/fridgeDetails/FridgeDetailsSelectDateBar.vue";
import FridgeDoorMonitorDailyItem from "@/components/fridgeDetails/FridgeDoorMonitorDailyItem.vue";
import HorizontalPaging from "@/components/common/HorizontalPaging.vue";

export default defineComponent({
  name: "FridgeDoorMonitorDaily",
  components: { FridgeDetailsSelectDateBar, FridgeDoorMonitorDailyItem, HorizontalPaging },
  props: {
    /** 選択初期値 */
    initialIndex: {
      type: Number,
      default: 0
    },
    /** ドア開閉情報 */
    list: {
      type: Array as PropType<FridgeDetailsDoorOpenInfoDailyItem[]>,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    NativeClient.sendDebugLog("FridgeDoorMonitorDaily setup start");
    NativeClient.sendDebugLog("FridgeDoorMonitorDaily list = " + JSON.stringify(props.list));

    // 表示更新のためのリアクティブ
    const updateDisplayKey = ref(0);
    const updateDisplay = () => {
      if (updateDisplayKey.value == 100) {
        updateDisplayKey.value = 0;
      } else {
        updateDisplayKey.value++;
      }
    };

    // 選択中の位置
    const { initialIndex } = toRefs(props);
    const selectIndex = ref(initialIndex.value);

    // const { initialIndex } = toRefs(props);
    // watch(initialIndex, () => {
    //   NativeClient.sendDebugLog("FridgeDoorMonitorDaily watch initialIndex");
    //   if (initialIndex.value != selectIndex.value) {
    //     selectIndex.value = initialIndex.value;
    //   }
    // });

    // 日付
    const dateListLength = ref(0);
    const dateList = computed(() => {
      const dateList: Array<string> = [];
      for (const item of props.list) {
          const dateString = translateYYYYMMDDToYYYYMDJapan(item.date);
          dateList.push(dateString);
      }
      dateListLength.value = dateList.length;
      return dateList;
    });
    const dateType = 2;
    const isDisableButtonHidden = true;

    const selectedDateIndex = (index: number) => {
      NativeClient.sendDebugLog("FridgeDoorMonitorDaily selectedDateIndex index = " + index);
      updateDisplay();
      selectIndex.value = index;
      context.emit("change-daily", index);
    };

    const selectPage = (index: number) => {
      NativeClient.sendDebugLog("FridgeDoorMonitorDaily selectPage index = " + index);
      selectIndex.value = index;
      context.emit("change-daily", index);
    }

    // ボタン押下
    const clickCaution = () => {
      NativeClient.sendDebugLog("FridgeDoorMonitorDaily clickCaution");
      context.emit("click-dooralarm");
    };

    onMounted(() => {
      NativeClient.sendDebugLog("FridgeDoorMonitorDaily onMounted initialIndex = " + props.initialIndex);
      selectIndex.value = props.initialIndex;
    });

    return {
      selectIndex,
      dateList,
      dateType,
      isDisableButtonHidden,
      selectedDateIndex,
      updateDisplayKey,
      selectPage,
      clickCaution
    };
  }
});
